// components/features/job-offers/JobOffersList.tsx
import { JobOffer } from "../../../types/features/JobOffer";
import TableList, { SelectAction } from "../../ui/TableList";
import JobOfferRow from "./JobOfferRow";

interface JobOffersListProps {
  jobOffers: JobOffer[];
  onAction: (jobOffer: JobOffer) => void;
  onSelectJobOffers?: (selectedJobOffers: JobOffer[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function JobOffersList({
  jobOffers,
  onAction,
  onSelectJobOffers,
  selectable = false,
  selectActions,
}: JobOffersListProps) {
  const columns = [
    { header: "Titre / Lieu", className: "w-2/5" },
    { header: "Type", className: "hidden sm:table-cell w-1/6" },
    { header: "Salaire", className: "hidden md:table-cell w-1/6" },
    { header: "Date limite", className: "hidden lg:table-cell w-1/6" },
    { header: "Statut", className: "hidden xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={jobOffers}
      columns={columns}
      getId={(jobOffer) => jobOffer.id}
      onAction={onAction}
      onSelectItems={onSelectJobOffers}
      selectable={selectable}
      emptyMessage="Aucune offre d'emploi trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(jobOffer, isSelected, onSelect) => (
        <JobOfferRow
          key={jobOffer.id}
          jobOffer={jobOffer}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}
